import { motion } from 'framer-motion';

export interface CalloutBlockProps {
  copy: string;
}

export function CalloutBlock({ copy }: CalloutBlockProps) {
  const bodyReveal = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { ease: [0, 1, 1, 1], duration: 0.8 },
    },
  };

  return (
    <motion.section className="w-full py-2" variants={bodyReveal} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.4 }}>
      <div className="container flex w-full items-start gap-5">
        <div className="w-2.5 self-stretch bg-gradient-to-b from-[#7b4a6d] to-[#1c0f1a]" />
        <div className="type-press-callout w-full" dangerouslySetInnerHTML={{ __html: copy }} />
      </div>
    </motion.section>
  );
}
